// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__2Qh+R","homeLogo":"Logo_homeLogo__ngPKH"};